/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  DataTablePrimeReact,
  PaginationERP,
  TableERP,
} from "@finanedi.es/storybook"
import { FetchDataRequestImpuestosDetalle } from "api/AsientoContable.service"
import { FacturaReadingSimpleDtoProps } from "api/DTOs/FacturaReadingSimpleDto"
import { getFacturasByIdSimple } from "api/Factura.service"
import { MODELO_IMPUESTO, ModeloImpuestoType } from "api/Types/ModeloImpuesto"
import { TIPO_DOCUMENTO_ENUM } from "api/Types/TipoDocumentoEnum"
import {
  TIPO_IMPUESTOS_MODELOS_ENUM,
  TipoImpuestoModeloType,
} from "api/Types/TipoImpuestosModelosEnum"
import { TrimestreEnumType } from "api/Types/TrimestreEnum"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import { AxiosResponse } from "axios"
import ModalVerDocumento from "common/components/ModalVerDocumento/ModalVerDocumento"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import notification from "common/utils/notification"
import { extractFilename } from "common/utils/utils"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import ModalAsientoContable from "features/Contabilidad/components/ModalAsientoContable/ModalAsientoContable"
import { MODELOS_IMPUESTOS } from "features/Contabilidad/pages/DetalleImpuestos/constants/modelosImpuestos"
import { TEXTO_TRIMESTRE } from "features/Contabilidad/pages/DetalleImpuestos/constants/textoTrimestre"
import { useFilterMenu } from "hooks/useFilterMenu"
import { useCallback, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { RESUMEN_IMPUESTO_DETAIL_COLUMNS, renderHeader } from "../../constant"
import FilterMenu from "./FilterMenu"

interface StateLocationProps {
  year: number
  modelo: ModeloImpuestoType
  periodo: TrimestreEnumType
  tipo: TipoImpuestoModeloType
}

const ResumenImpuestosDetail = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const state = location.state as StateLocationProps
  const { handleDirectDownloadExcel } = useDownloadFileContext()

  // MODALES
  const [showModalAsiento, setShowModalAsiento] = useState(false)
  const [asientoSelectedEdit, setAsientoSelectedEdit] = useState<string>("")
  const [modalDocumentoDetail, setModalDocumentoDetail] = useState<{
    show: boolean
    document: FacturaReadingSimpleDtoProps | null
  }>({
    show: false,
    document: null,
  })

  const [sortingCriteria, setSortingCriteria] = useState<SortingCriteria>({
    sort: "DESC",
    property: "asientoContable.numero",
  })
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)
  const dtRef = useRef<DataTablePrimeReact<
    FacturaReadingSimpleDtoProps[]
  > | null>(null)

  const fetchItems = useCallback(() => {
    return (queryState: FetchDataRequestImpuestosDetalle) =>
      MODELOS_IMPUESTOS()[state.modelo].serviceResumenDetalle({
        ...queryState,
        Anyo: state.year,
        Periodo: state.periodo,
        ...((state.tipo === TIPO_IMPUESTOS_MODELOS_ENUM.IMPUESTO_SOPORTADO ||
          state.tipo === TIPO_IMPUESTOS_MODELOS_ENUM.IMPUESTO_REPERCUTIDO) && {
          TipoImpuestoIVA: state.tipo,
        }),
        SortingCriteria: queryState.SortingCriteria,
        MaxResultCount: queryState?.MaxResultCount ?? pagination.itemsPerPage,
      })
  }, [
    state.modelo,
    state.year,
    state.periodo,
    state.tipo,
    pagination.itemsPerPage,
  ])

  const { items, isLoading, totalCount, setServiceQuery, fetchTableData } =
    useFilterMenu({
      serviceCall: fetchItems,
    })

  const handleOpenAsientoModal = async (id: string) => {
    setAsientoSelectedEdit(id)
    setShowModalAsiento(true)
  }

  const handleOpenDocumentoModal = async (id: string) => {
    const facturaById = await getFacturasByIdSimple(id)
    setModalDocumentoDetail({
      show: true,
      document: facturaById,
    })
  }

  const goBack = () => {
    history.goBack()
  }

  const onSuccessDowloadFile = (
    response: AxiosResponse,
    headers: Record<string, string>
  ) => {
    const nameFile = extractFilename(headers["content-disposition"])
    handleDirectDownloadExcel(response, nameFile)
  }

  const requestHandleDownloadXml = async (): Promise<void> => {
    try {
      const data = await MODELOS_IMPUESTOS()[
        state.modelo
      ].serviceExportResumenDetalle({
        Anyo: state.year,
        Periodo: state.periodo,
        ...((state.modelo === MODELO_IMPUESTO.MODELO_303 ||
          state.modelo === MODELO_IMPUESTO.MODELO_390) && {
          TipoImpuestoIVA: state.tipo,
        }),
        SortingCriteria: sortingCriteria,
      })
      onSuccessDowloadFile(data, data.headers)
      notification.success({
        body: `${t("taxSummary.detail.msg.downloadSuccess")}`,
      })
    } catch (error) {
      notification.errorServidor({
        body: `${t("taxSummary.detail.msg.downloadError")}`,
      })
    }
  }

  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }
  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
    handleResetPagination()
  }

  return (
    <>
      <div className='tw-w-full tw-h-[70px] tw-flex tw-flex-row tw-px-8 tw-py-3 tw-items-center tw-justify-between tw-bg-white tw-border-b tw-border-gray-200'>
        {renderHeader({
          t,
          trimester: TEXTO_TRIMESTRE(t)[state.periodo],
          year: state.year,
          goBack,
          modelNumber: state.modelo,
          type: state.tipo,
        })}

        <FilterMenu
          serviceQuery={setServiceQuery}
          sortingCriteria={sortingCriteria}
          maxResultCount={pagination.itemsPerPage}
          skipCount={pagination.skipCount}
          resetPagination={handleResetPagination}
          handleDownload={requestHandleDownloadXml}
        />
      </div>

      <div className='tw-flex tw-flex-col tw-h-[calc(100%-70px)] tw-relative '>
        <div className='tw-h-[calc(100%-60px)] tw-min-h-0'>
          <TableERP
            refTable={dtRef}
            columns={RESUMEN_IMPUESTO_DETAIL_COLUMNS(t, state.modelo, {
              handleOpenAsientoModal,
              handleOpenDocumentoModal,
            })}
            className='tw-h-full'
            columnResizeMode='expand'
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            removableSort
            value={items}
            showGridlines
            dataKey='id'
            lazy
            scrollable
            size='small'
            loading={isLoading}
            emptyMessage={t("primeReact.table.emptyMessage")}
          />
          <PaginationERP
            className={PAGINATION_STYLES}
            totalRecords={totalCount}
            first={pagination.skipCount}
            rows={pagination.itemsPerPage}
            resetScroll={() => dtRef.current && dtRef.current?.resetScroll()}
            setPagination={setPagination}
            optionDropdown={[10, 20, 50, 100]}
            texts={{
              textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
              textCurrentPageReport: `${t("pagination.from")}`,
            }}
          />
        </div>
      </div>
      <ModalAsientoContable
        idToEdit={asientoSelectedEdit}
        show={showModalAsiento}
        setShow={setShowModalAsiento}
        updateTable={fetchTableData}
      />
      <ModalVerDocumento
        showModal={modalDocumentoDetail.show}
        onHide={() =>
          setModalDocumentoDetail({
            show: false,
            document: null,
          })
        }
        docType={TIPO_DOCUMENTO_ENUM.FACTURA}
        documentoID={modalDocumentoDetail.document?.id ?? null}
        typeDocumentTable='facturas'
      />
    </>
  )
}

export default ResumenImpuestosDetail
